import type { AchievementBackgroundProps } from '../Achievement';
import Chrome from '../assets/Chrome.png';

export const QuestBackground = ({ size }: AchievementBackgroundProps) => (
  <img src={Chrome} alt="Chrome background" width={size} height={size} />
);
